export enum TimecardEventType {
  ACTIVITY = 'ACTIVITY',
  URL_ACTIVITY = 'URL_ACTIVITY'
}
